// extracted by mini-css-extract-plugin
module.exports = {"upload":"upload--f2e5f"};